import axios from "axios";

const URL_API = process.env.REACT_APP_BACKEND_URL;

class Service {
  constructor() {
    let service = axios.create({
      baseURL: URL_API,
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    // service.interceptors.request.use(
    //   (config) => {
    //     // Check and acquire a token before the request is sent
    //     return new Promise((resolve, reject) => {
    //       authContext.acquireToken(
    //         adalConfig.endpoints.api,
    //         (message, token, msg) => {
    //           if (!!token) {
    //             config.headers.Authorization = `Bearer ${token}`;
    //             resolve(config);
    //           } else {
    //             // Do something with error of acquiring the token
    //             reject(config);
    //           }
    //         }
    //       );
    //     });
    //   },
    //   function (error) {
    //     // Do something with error of the request
    //     return Promise.reject(error);
    //   }
    // );
    this.service = service;
  }

  handleSuccess(response) {
    return response;
  }

  handleError = (error) => {
    return Promise.reject(error);
  };

  get(path, header, callback) {
    return this.service
      .get(path)
      .then((response) => callback(response.status, response.data))
      .catch((err) => callback(err, err));
  }

  patch(path, header, payload, callback) {
    return this.service
      .request({
        method: "PATCH",
        url: path,
        headers: header,
        data: payload,
      })
      .then((response) => callback(response.status, response.data));
  }

  post(path, header, payload, callback) {
    return this.service
      .request({
        method: "POST",
        url: path,
        data: payload,
      })
      .then((response) => callback(response.status, response.data))
      .catch((err) => callback(err));
  }
}

const apiService = new Service();
export default apiService;

